import type { MaybeRefOrGetter } from 'vue';

import { computed, ref, toValue, watch } from 'vue';

/** Preserve sidebar edits only within the search whose invalid agent is removed. */
export function useAgentFilterDraftPreservation(
	isSidebarActive: MaybeRefOrGetter<boolean>
) {
	const route = useRoute();
	const router = useRouter();
	const cleanupPath = ref<string>();
	const preserveSidebarDrafts = computed(
		() => toValue(isSidebarActive) && Boolean(cleanupPath.value)
	);

	function preserveDraftsForAgentRemoval() {
		if (!toValue(isSidebarActive)) return;

		const query = { ...route.query };
		delete query.agentSlug;
		delete query.page;
		cleanupPath.value = router.resolve({
			path: route.path,
			query,
			hash: route.hash
		}).fullPath;
	}

	watch(
		() => route.fullPath,
		path => {
			// The automatic replace may reset and repopulate filters separately.
			// Preserve edits through both, but never carry them into another search.
			if (path !== cleanupPath.value) cleanupPath.value = undefined;
		},
		{ flush: 'sync' }
	);
	watch(
		() => toValue(isSidebarActive),
		isActive => {
			if (!isActive) cleanupPath.value = undefined;
		},
		{ flush: 'sync' }
	);

	return { preserveSidebarDrafts, preserveDraftsForAgentRemoval };
}
